'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionIntroCarousel = function () {
  function CollectionIntroCarousel(el) {
    (0, _classCallCheck3.default)(this, CollectionIntroCarousel);

    this.el = el;

    this.setupListeners();
  }

  (0, _createClass3.default)(CollectionIntroCarousel, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.shortButtonEl.addEventListener('click', function () {
        _this.toggleReadMore();
      });

      this.longButtonEl.addEventListener('click', function () {
        _this.toggleReadLess();
      });
    }
  }, {
    key: 'toggleReadMore',
    value: function toggleReadMore() {
      this.shortDescriptionEl.setAttribute('aria-hidden', 'true');
      this.longDescriptionEl.setAttribute('aria-hidden', 'false');
    }
  }, {
    key: 'toggleReadLess',
    value: function toggleReadLess() {
      this.shortDescriptionEl.setAttribute('aria-hidden', 'false');
      this.longDescriptionEl.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: 'shortDescriptionEl',
    get: function get() {
      return (0, _functional.getElement)('[data-collection-read-more-el="shortDescription"]', {
        context: this.el
      });
    }
  }, {
    key: 'shortButtonEl',
    get: function get() {
      return (0, _functional.getElement)('[data-collection-read-more-el="shortButton"]', {
        context: this.el
      });
    }
  }, {
    key: 'longDescriptionEl',
    get: function get() {
      return (0, _functional.getElement)('[data-collection-read-more-el="longDescription"]', {
        context: this.el
      });
    }
  }, {
    key: 'longButtonEl',
    get: function get() {
      return (0, _functional.getElement)('[data-collection-read-more-el="longButton"]', {
        context: this.el
      });
    }
  }]);
  return CollectionIntroCarousel;
}();

exports.default = CollectionIntroCarousel;